import { Tooltip as T } from 'radix-ui'
import type { ReactElement, ReactNode } from 'react'
import { Keys } from './Kbd.tsx'

export interface TooltipProps {
  content: ReactNode
  /** Optional shortcut shown as keycaps after the text. */
  keys?: string
  side?: 'top' | 'right' | 'bottom' | 'left'
  children: ReactElement
  delay?: number
}

export function Tooltip({ content, keys, side = 'bottom', children, delay }: TooltipProps) {
  if (content === null || content === undefined || content === false) return children
  return (
    <T.Root delayDuration={delay}>
      <T.Trigger asChild>{children}</T.Trigger>
      <T.Portal>
        <T.Content className="rt-tooltip" side={side} sideOffset={6} collisionPadding={8}>
          <span>{content}</span>
          {keys ? <Keys keys={keys} /> : null}
        </T.Content>
      </T.Portal>
    </T.Root>
  )
}

export const TooltipProvider = T.Provider
